/**
 * store search condition of prohibition
 */
const state = {
  prohibitionSearchCondition: null
};

const getters = {
  prohibitionSearchCondition: state => state.prohibitionSearchCondition
};

const mutations = {
  saveProhibitionSearchCondition(state, prohibitionSearchCondition) {
    if (!prohibitionSearchCondition) {
      return;
    }
    state.prohibitionSearchCondition = prohibitionSearchCondition;
  },
  clearProhibitionSearchCondition(state) {
    state.prohibitionSearchCondition = null;
  }
};

export default {
  state,
  getters,
  mutations
};
